import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56b0dd9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "external-examiner-dashboard" }
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Appointed", -1))
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Practices", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "space-filler",
  style: {"flex-grow":"1"}
}, null, -1))
const _hoisted_7 = { class: "table-section" }
const _hoisted_8 = { class: "ls-table" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-up" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["colspan"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["colspan"]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = ["colspan"]
const _hoisted_18 = ["title"]
const _hoisted_19 = { "data-label": "Law Practice ID" }
const _hoisted_20 = ["title"]
const _hoisted_21 = { "data-label": "Appointed Date" }
const _hoisted_22 = { "data-label": "Terminated Date" }
const _hoisted_23 = { "data-label": "Actions" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_AddAppointedPracticeModal = _resolveComponent("AddAppointedPracticeModal")
  const _component_ViewTerminatePracticeModal = _resolveComponent("ViewTerminatePracticeModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("button", {
          class: "btn btn-primary mr-2",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.showAddAppointedPracticeModal = true))
        }, "Add new practice")
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("table", _hoisted_8, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", {
                class: _normalizeClass([ h.sortable ? 'sortable' : ''])
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(h.text), 1),
                  (h.sortable)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass([ _ctx.activeSortHeader === index ? 'active' : '', h.sortMethod])
                      }, _hoisted_11, 2))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                _createElementVNode("td", {
                  colspan: _ctx.tableHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_13)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_15)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.practiceList.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                    _createElementVNode("td", {
                      colspan: _ctx.tableHeadings.length
                    }, "No results found.", 8, _hoisted_17)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.practiceList.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.practiceList, (p) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", {
                          "data-label": "Practice Name",
                          title: p.practiceName
                        }, _toDisplayString(p.practiceName), 9, _hoisted_18),
                        _createElementVNode("td", _hoisted_19, _toDisplayString(p.firmId), 1),
                        _createElementVNode("td", {
                          "data-label": "Branch Address",
                          title: p.address
                        }, _toDisplayString(p.address), 9, _hoisted_20),
                        _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.$formatDate(p.effectiveStartDate)), 1),
                        _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.$formatDate(p.effectiveEndDate)), 1),
                        _createElementVNode("td", _hoisted_23, [
                          (p.effectiveEndDate)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-default sml ml-1 mr-1",
                                onClick: $event => (_ctx.openView(p))
                              }, "View", 8, _hoisted_24))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-default sml ml-1 mr-1",
                                onClick: $event => (_ctx.openView(p))
                              }, "Edit", 8, _hoisted_25))
                        ])
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showAddAppointedPracticeModal)
      ? (_openBlock(), _createBlock(_component_AddAppointedPracticeModal, {
          key: 0,
          onClose: _cache[1] || (_cache[1] = $event => (_ctx.showAddAppointedPracticeModal = false)),
          onRefresh: _ctx.getPractice
        }, null, 8, ["onRefresh"]))
      : _createCommentVNode("", true),
    (_ctx.showViewTerminatePracticeModal)
      ? (_openBlock(), _createBlock(_component_ViewTerminatePracticeModal, {
          key: 1,
          onClose: _cache[2] || (_cache[2] = $event => (_ctx.showViewTerminatePracticeModal = false)),
          onRefresh: _ctx.getPractice,
          selectedPractice: _ctx.selectedPractice,
          "onUpdate:selectedPractice": _cache[3] || (_cache[3] = $event => ((_ctx.selectedPractice) = $event))
        }, null, 8, ["onRefresh", "selectedPractice"]))
      : _createCommentVNode("", true)
  ]))
}